<!--  -->
<template>
  <div class="page">
    <div class="login" v-if="login">
      <h2><b>登录</b></h2>
      <a-form @submit="onSubmit" :form="form">
        <a-alert
          type="error"
          :closable="true"
          v-show="error"
          :message="error"
          showIcon
          style="margin-bottom: 24px;"
        />
        <a-form-item>
          <a-input
            autocomplete="autocomplete"
            size="large"
            placeholder="请输入账户名"
            v-decorator="[
              'tel',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入账户名',
                    whitespace: true
                  }
                ]
              }
            ]"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="请输入密码"
            autocomplete="autocomplete"
            type="password"
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '请输入密码', whitespace: true }
                ]
              }
            ]"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            :loading="logging"
            style="width: 100%;margin-top: 15px"
            size="large"
            htmlType="submit"
            type="primary"
            >登录</a-button
          >
        </a-form-item>
        <div style="text-align:right" @click="login = !login">
          <a href="javascript:;">注册账户</a>
        </div>
      </a-form>
    </div>
    <div class="register" v-else>
      <h2><b>注册</b></h2>
      <a-form @submit="registerSubmit" :form="regform">
        <a-alert
          type="error"
          :closable="true"
          v-show="error"
          :message="error"
          showIcon
          style="margin-bottom: 15px;"
        />
        <a-form-item>
          <a-input
            autocomplete="autocomplete"
            size="large"
            placeholder="请输入账户名"
            v-decorator="[
              'tel',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入账户名',
                    whitespace: true
                  }
                ]
              }
            ]"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="请输入密码"
            autocomplete="autocomplete"
            type="password"
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '请输入密码', whitespace: true }
                ]
              }
            ]"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            :loading="logging"
            style="width: 100%;margin-top: 15px"
            size="large"
            htmlType="submit"
            type="primary"
            >注册</a-button
          >
        </a-form-item>
        <div style="text-align:right" @click="login = !login">
          <a href="javascript:;">前往登录</a>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { createUserlogin, createUserDetail } from "@/api/api-user.js";
export default {
  components: {},
  data() {
    return {
      error: "",
      logging: false,
      login: true,
      form: this.$form.createForm(this),
      regform: this.$form.createForm(this)
    };
  },
  computed: {},
  watch: {},
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          createUserlogin({ ...values }).then(res => {
            if (res.length == 0) {
              this.$message.success("登录成功");
              setTimeout(() => {
                this.$emit("loginSuccess");
              }, 1200);
            }
          });
        }
      });
    },
    registerSubmit(e) {
      e.preventDefault();
      this.regform.validateFields((err, values) => {
        if (!err) {
          console.log(e);
          createUserDetail({ ...values }).then(res => {
            if (res.length == 0) {
              this.$message.success("注册成功");
              this.login = true;
            }
          });
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.page {
  padding-top: 60px;
  width: 350px;
  margin: 0 auto;
  min-height: 200px;
}
/deep/ .steps-content {
  border: 0;
}
</style>
